module.exports = __webpack_public_path__ + "vue_assets/img/img_app_preview_linux.a1cebbc8.png";